import React from 'react';
import { connect } from 'react-redux';
import { bool } from 'prop-types';
import { compose } from 'redux';

import { propTypes } from '../../util/types';
import LandingPage from '../LandingPage/LandingPage';
import MarketingPage from '../MarketingPage/MarketingPage';

// This component conditionally renders either the marketing page (for unauthenticated users)
// or the dashboard/landing page (for authenticated users)
const HomePage = props => {
  const { currentUser = null, isAuthenticated } = props;

  // Show dashboard for authenticated users
  if (isAuthenticated) {
     return <LandingPage {...props} />;
  }

  // Show marketing page for unauthenticated users
  return <MarketingPage {...props} />;
};



HomePage.propTypes = {
  currentUser: propTypes.currentUser,
  isAuthenticated: bool.isRequired,
};

const mapStateToProps = state => {
  const { currentUser, isAuthenticated } = state.auth;

  return {
    currentUser,
    isAuthenticated,
  };
};

export default compose(connect(mapStateToProps))(HomePage);
